// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/comparison-exchange/comparison-exchange.component.scss
// module id = 332
// module chunks = 0